<div class="title-row" fxLayout="row" fxLayoutAlign="space-between center">
  <main class="title-simple-steps">
    <h1>
      {{ titleKey | translate }}
      <span class="text-[#6059a2]">*</span>
    </h1>
    <p *ngIf="descriptionKey" class="step-description my-2">{{ descriptionKey | translate }}</p>
  </main>
  <button *ngIf="showSkip" type="button" class="skip-btn" (click)="onSkip()" [disabled]="skipLoading">
    {{ "Skip" | translate }}
    <span class="btn-spinner-icon" *ngIf="skipLoading"></span>
  </button>
</div>

<form
  class="sign-up-form"
  fxLayout="column"
  fxLayoutAlign="start stretch"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
>
  <div class="same-hours-for-all-days-row mb-[23px] md:mb-[32px]">
    <div class="same-hours-wrapper">
      <label class="ios-switch">
        <input
          type="checkbox"
          [(ngModel)]="selectAllDays"
          (change)="checkAllFromInput($event)"
          [ngModelOptions]="{ standalone: true }"
        />
        <span class="slider"></span>
      </label>
      <span class="same-hours-label">{{ "Same_Hours_For_All_Days" | translate }}</span>
    </div>
    <div class="all-days-times" *ngIf="selectAllDays">
      <input
        type="time"
        class="time-input"
        [(ngModel)]="startAll"
        (change)="onChangeAllTime('start', $event)"
        [ngModelOptions]="{ standalone: true }"
      />
      <span class="to-separator">{{ "TO" | translate }}</span>
      <input
        type="time"
        class="time-input"
        [(ngModel)]="endAll"
        (change)="onChangeAllTime('end', $event)"
        [ngModelOptions]="{ standalone: true }"
      />
    </div>
  </div>

  <div class="field-group days-list" *ngIf="!workingDaysLoading; else workingDaysSkeleton">
    <div
      *ngFor="let item of workingDays"
      class="day-row"
      [ngClass]="{ 'day-row-closed': !item.checked }">
      <div class="bt-1 terms-checkbox-wrap">
        <mat-checkbox
          class="day-checkbox"
          color="primary"
          [(ngModel)]="item.checked"
          [ngModelOptions]="{ standalone: true }">
          {{ dir == 'rtl' ? item.NameAr : item.NameEn | translate }}
        </mat-checkbox>
      </div>
      <div class="day-times" *ngIf="item.checked">
        <input
          type="time"
          class="time-input"
          [(ngModel)]="item.StartTime"
          [ngModelOptions]="{ standalone: true }"
        />
        <span class="to-separator">{{ "To" | translate }}</span>
        <input
          type="time"
          class="time-input"
          [(ngModel)]="item.FinishTime"
          [ngModelOptions]="{ standalone: true }"
        />
      </div>
      <span *ngIf="!item.checked" class="closed-label">{{ "Closed" | translate }}</span>
    </div>
  </div>

  <ng-template #workingDaysSkeleton>
    <div class="days-skeleton">
      <div class="day-row-skeleton" *ngFor="let i of [1,2,3,4,5,6,7]">
        <div class="skeleton-day-label"></div>
        <div class="skeleton-day-times"></div>
      </div>
    </div>
  </ng-template>

  <div class="actions-buttons mb-[16px]" *ngIf="showActions">
    <button
      type="button"
      class="action-btn prev-btn"
      (click)="onPrevious()">
      {{ previousLabelKey | translate }}
    </button>
    <button
      mat-raised-button
      class="action-btn submit-btn"
      type="submit"
      [disabled]="loading">
      {{ submitLabelKey | translate }}
      <span class="btn-spinner-icon" *ngIf="loading"></span>
    </button>
  </div>
</form>
